import { gameEdition } from "./edition.ts";

/**
 * Kelime anlamları.
 *
 * Dosya `npm run meanings` ile derleme öncesi üretiliyor ve kelime listeleri
 * gibi statik varlık olarak geliyor — uygulama çalışırken dışarıya bağlanmıyor,
 * pratik modu çevrimdışıyken de anlam gösterebiliyor.
 *
 * Sayfa dosyayı ancak oyuncu "ne demek" dediğinde istiyor; açılışta ve sonuç
 * paneli açılırken hiçbir ağ isteği yok. Uygulama olarak kurulduğunda ise
 * servis çalışanı dosyayı kurulum sırasında önbelleğe alıyor (sıkıştırılmış
 * ~62 KB) — çevrimdışı pratikte de anlam gösterilebilsin diye.
 */

export interface Meaning {
  definition: string;
  /** "isim" / "noun" gibi; sözlükte yoksa boş. */
  partOfSpeech?: string;
}

export type MeaningMap = Record<string, Meaning>;

let cache: Promise<MeaningMap> | null = null;

export function loadMeanings(): Promise<MeaningMap> {
  cache ??= fetch("/meanings.json")
    .then((res) => {
      if (!res.ok) throw new Error(`Definitions could not be loaded (${res.status})`);
      return res.json() as Promise<MeaningMap>;
    })
    .catch((err: unknown) => {
      // Bir dahaki denemede yeniden istensin; başarısız söz saklanmasın.
      cache = null;
      throw err;
    });
  return cache;
}

/** Sözlükte karşılığı olmayan kelimeler var; o durumda null döner. */
export function meaningFor(map: MeaningMap, word: string): Meaning | null {
  return map[gameEdition.normalizeWord(word)] ?? null;
}
